import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AuthContext, base_url } from "../context/Authcontext";
import '../../src/assets/AdminCss/dropdown.css';
import { useTheme } from "../context/ThemeContext";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";
import { AiOutlinePlusSquare } from "react-icons/ai";
import { FaRegMinusSquare } from "react-icons/fa";
import { RiCloseCircleLine } from "react-icons/ri";


export const Sidebar = ({ isSidebar, setSidebar }) => {
  const navigate = useNavigate();
  const { themeColors } = useTheme();
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [sidebaar, setsidebaar] = useState(false);
  const { isAuthenticated, setIsAuthenticated } = useContext(AuthContext);

  const [sections, setSections] = useState({
    racing: true,
    others: true,
    allSports: true,
  });

  const [subSections, setSubSections] = useState({
    politics: false,
    cricket: false,
    max60: false,
    others: false,
    shpLeague: false,
    womens: false,
  });

  const toggleSection = (key) => {
    setSections((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const toggleSubSection = (key) => {
    setSubSections((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const handleHamburger = () => {
    setSidebar(prev => !prev);
    if (isMobile) setsidebaar(false);
  };

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();

    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleSideLink = () => {
    toast.success('Coming Soon');

  };

  const handleClicktoast = () => {
    toast.success("Coming soon");
  };

  const isSmallScreen = window.innerWidth <= 768;
  const styles = {
    popular: {
      display: "flex",
      color: 'var(--dark-theme-color-navbar)',
      justifyContent: 'space-between',
    },
    close: {
      display: isSmallScreen ? "block" : 'none',
      paddingRight: "2px",
    },
    reactIcon: {
      height: "17px",
      width: "17px",
      fontWeight: 'bold',
    },
    plusIcon: {
      height: "17px",
      width: "17px",
      fontWeight: 'bold',
    },
    minusIcon: {
      height: "15px",
      width: "15px",
      fontWeight: 'bold',
    },
  }

  return (
    <>
      <div _ngcontent-jrx-c95="" id="sidebar-landing"
      >
        <app-sidebar
          _ngcontent-jrx-c95=""
          _nghost-jrx-c79=""
          className="ng-star-inserted"
        >
          <nav _ngcontent-jrx-c79="" id="sidebar" className="collapse show showMargin"
            style={{
              ...styles.sidebar,
              transform: isSidebar ? "translateX(0%)" : "translateX(-100%)",
              transition: "transform 0.3s ease-in-out",
              display: "flex",
              flexDirection: "column",

            }}
          >                              
           {/* {isSmallScreen && ( */}           
             <div className="p-2 d-flex d-md-flex d-lg-none" style={{ backgroundColor: '#ebebeb' }}>
              <div className="w-100 fw-bold ps-0 my-auto py-1" style={styles.popular}>
                <input placeholder="Search here" style={{width: "85%"}} className="text-dark py-2 border border-1" />
                {isSidebar && (
                <Link
                  _ngcontent-mkq-c111=""
                  data-target="nav-mobile mt-5"
                  style={styles.close}
                  className="sidenav-trigger ms-auto"
                  onClick={handleHamburger}
                >
                  <RiCloseCircleLine style={{fontSize: "30px"}} />
                </Link>
              )}
              </div>
            </div>
           {/* )} */}
            <div className="sidebar-menu">
              <div className="menu-section">
                <div className="menu-header" onClick={() => toggleSection('racing')}>
                  Racing Sports
                  <span className="arrow">{sections.racing ? (<IoIosArrowUp style={styles.reactIcon} />) : (<IoIosArrowDown style={styles.reactIcon} />)}</span>
                </div>
                {sections.racing && (
                  <div className="menu-items">
                    <div className="menu-item" onClick={handleClicktoast}>Horse Racing</div>
                    <div className="menu-item" onClick={handleClicktoast}>Greyhound Racing</div>
                  </div>
                )}
              </div>

              <div className="menu-section">
                <div className="menu-header" onClick={() => toggleSection('others')}>
                  Others
                  <span className="arrow">{sections.others ? (<IoIosArrowUp style={styles.reactIcon} />) : (<IoIosArrowDown style={styles.reactIcon} />)}</span>
                </div>
                {sections.others && (
                  <div className="menu-items">
                    {/* <div onClick={() => navigate("/casinoGames")} className="menu-item blink_me">Our Casino</div> */}
                    <div className="menu-item blink_me" onClick={() =>
                    navigate("/casinoGames", { state: { list: 0 } })
                  }>All Casino</div>
                    <div className="menu-item"  onClick={() =>
                    navigate("/casinoGames", { state: { list: 7 } })
                  }>Live Casino</div>
                    <div className="menu-item"    onClick={() =>
                    navigate("/casinoGames", { state: { list: 16 } })
                  }>Slot Game</div>
                    <div className="menu-item" onClick={() => navigate('/casinoGames', { state: { list: 15 } })}>BlackJack</div>
                  </div>
                )}
              </div>

              {/* All Sports */}
              <div className="menu-section">
                <div className="menu-header" onClick={() => toggleSection('allSports')}>
                  All Sports
                  <span className="arrow">{sections.allSports ? (<IoIosArrowUp style={styles.reactIcon} />) : (<IoIosArrowDown style={styles.reactIcon} />)}</span>
                </div>
                {sections.allSports && (
                  <div className="menu-items">
                    <div className="menu-item" onClick={() => toggleSubSection('politics')}>
                      <span className="toggle-icon">
                        {subSections.politics ? (<FaRegMinusSquare style={styles.minusIcon} />) : (<AiOutlinePlusSquare style={styles.plusIcon} />)}
                      </span>{' '}
                      Politics
                    </div>
                    {/* 
                    <div className="menu-item" onClick={() => toggleSubSection('cricket')}>
                      <span className="toggle-icon">
                        {subSections.cricket ? (<FaRegMinusSquare style={styles.minusIcon} />): (<AiOutlinePlusSquare style={styles.plusIcon} />)}
                      </span>{' '}
                      Cricket
                    </div>

                    {subSections.cricket && (
                      <div className="submenu">
                        <div className="menu-item" onClick={() => toggleSubSection('max60')}>
                          <span className="toggle-icon">
                            {subSections.max60 ? (<FaRegMinusSquare style={styles.minusIcon} />): (<AiOutlinePlusSquare style={styles.plusIcon} />)}
                          </span>{' '}
                          Max60
                        </div>
                      </div>
                    )} */}

                    {/* <div
                      className="menu-item"
                      onClick={() => {
                        toggleSubSection('inplay');
                        navigate('/inplay');
                      }}
                    >
                      <span className="toggle-icon">
                        {subSections.inplay ? (<FaRegMinusSquare style={styles.minusIcon} />): (<AiOutlinePlusSquare style={styles.plusIcon} />)}
                      </span>{' '}
                      In-Play
                    </div> */}

                    <div className="menu-item" onClick={() => { toggleSubSection('cricket'); navigate("/cricketreal") }}>
                      <span className="toggle-icon">
                        {subSections.cricket ? (<FaRegMinusSquare style={styles.minusIcon} />) : (<AiOutlinePlusSquare style={styles.plusIcon} />)}
                      </span>{' '}
                      Cricket
                    </div>
                    <div className="menu-item" onClick={() => { toggleSubSection('football'); navigate("/footballreal") }}>
                      <span className="toggle-icon">
                        {subSections.football ? (<FaRegMinusSquare style={styles.minusIcon} />) : (<AiOutlinePlusSquare style={styles.plusIcon} />)}
                      </span>{' '}
                      Football
                    </div>
                    <div className="menu-item" onClick={() => { toggleSubSection('tennis'); navigate("/tennisreal"); }}>
                      <span className="toggle-icon">
                        {subSections.tennis ? (<FaRegMinusSquare style={styles.minusIcon} />) : (<AiOutlinePlusSquare style={styles.plusIcon} />)}
                      </span>{' '}
                      Tennis
                    </div>
                    <div className="menu-item" onClick={() => toggleSubSection('soccer')}>
                      <span className="toggle-icon">
                        {subSections.soccer ? (<FaRegMinusSquare style={styles.minusIcon} />) : (<AiOutlinePlusSquare style={styles.plusIcon} />)}
                      </span>{' '}
                      Soccer
                    </div>
                    <div className="menu-item" onClick={() => toggleSubSection('Esports')}>
                      <span className="toggle-icon">
                        {subSections.Esports ? (<FaRegMinusSquare style={styles.minusIcon} />) : (<AiOutlinePlusSquare style={styles.plusIcon} />)}
                      </span>{' '}
                      Esports
                    </div>
                    <div className="menu-item" onClick={() => toggleSubSection('Boat')}>
                      <span className="toggle-icon">
                        {subSections.Boat ? (<FaRegMinusSquare style={styles.minusIcon} />) : (<AiOutlinePlusSquare style={styles.plusIcon} />)}
                      </span>{' '}
                      Boat Racing
                    </div>
                    <div className="menu-item" onClick={() => toggleSubSection('Darts')}>
                      <span className="toggle-icon">
                        {subSections.Darts ? (<FaRegMinusSquare style={styles.minusIcon} />) : (<AiOutlinePlusSquare style={styles.plusIcon} />)}
                      </span>{' '}
                      Darts
                    </div>
                    <div className="menu-item" onClick={() => toggleSubSection('American')}>
                      <span className="toggle-icon">
                        {subSections.American ? (<FaRegMinusSquare style={styles.minusIcon} />) : (<AiOutlinePlusSquare style={styles.plusIcon} />)}
                      </span>{' '}
                      American Football
                    </div>
                    <div className="menu-item" onClick={() => toggleSubSection('Rugby')}>
                      <span className="toggle-icon">
                        {subSections.Rugby ? (<FaRegMinusSquare style={styles.minusIcon} />) : (<AiOutlinePlusSquare style={styles.plusIcon} />)}
                      </span>{' '}
                      Rugby Union
                    </div>
                    <div className="menu-item" onClick={() => toggleSubSection('Motor')}>
                      <span className="toggle-icon">
                        {subSections.Motor ? (<FaRegMinusSquare style={styles.minusIcon} />) : (<AiOutlinePlusSquare style={styles.plusIcon} />)}
                      </span>{' '}
                      Motor Sports
                    </div>
                    <div className="menu-item" onClick={() => toggleSubSection('Athletics')}>
                      <span className="toggle-icon">
                        {subSections.Athletics ? (<FaRegMinusSquare style={styles.minusIcon} />) : (<AiOutlinePlusSquare style={styles.plusIcon} />)}
                      </span>{' '}
                      Athletics
                    </div>
                    <div className="menu-item" onClick={() => toggleSubSection('Sumo')}>
                      <span className="toggle-icon">
                        {subSections.Sumo ? (<FaRegMinusSquare style={styles.minusIcon} />) : (<AiOutlinePlusSquare style={styles.plusIcon} />)}
                      </span>{' '}
                      Sumo
                    </div>
                    <div className="menu-item" onClick={() => toggleSubSection('Cycling')}>
                      <span className="toggle-icon">
                        {subSections.Cycling ? (<FaRegMinusSquare style={styles.minusIcon} />) : (<AiOutlinePlusSquare style={styles.plusIcon} />)}
                      </span>{' '}
                      Cycling
                    </div>
                    <div className="menu-item" onClick={() => toggleSubSection('Chess')}>
                      <span className="toggle-icon">
                        {subSections.Chess ? (<FaRegMinusSquare style={styles.minusIcon} />) : (<AiOutlinePlusSquare style={styles.plusIcon} />)}
                      </span>{' '}
                      Chess
                    </div>
                    <div className="menu-item" onClick={() => toggleSubSection('Volleyball')}>
                      <span className="toggle-icon">
                        {subSections.Volleyball ? (<FaRegMinusSquare style={styles.minusIcon} />) : (<AiOutlinePlusSquare style={styles.plusIcon} />)}
                      </span>{' '}
                      Volleyball
                    </div>
                     <div className="menu-item" onClick={() => toggleSubSection('Chess')}>
                      <span className="toggle-icon">
                        {subSections.Volleyball ? (<FaRegMinusSquare style={styles.minusIcon} />) : (<AiOutlinePlusSquare style={styles.plusIcon} />)}
                      </span>{' '}
                      Chess
                    </div>
                     <div className="menu-item" onClick={() => toggleSubSection('HandBall')}>
                      <span className="toggle-icon">
                        {subSections.Volleyball ? (<FaRegMinusSquare style={styles.minusIcon} />) : (<AiOutlinePlusSquare style={styles.plusIcon} />)}
                      </span>{' '}
                      HandBall
                    </div>
                     <div className="menu-item" onClick={() => toggleSubSection('Cycling')}>
                      <span className="toggle-icon">
                        {subSections.Volleyball ? (<FaRegMinusSquare style={styles.minusIcon} />) : (<AiOutlinePlusSquare style={styles.plusIcon} />)}
                      </span>{' '}
                      Cycling
                    </div>
                     <div className="menu-item" onClick={() => toggleSubSection('Sumo')}>
                      <span className="toggle-icon">
                        {subSections.Volleyball ? (<FaRegMinusSquare style={styles.minusIcon} />) : (<AiOutlinePlusSquare style={styles.plusIcon} />)}
                      </span>{' '}
                      Sumo 
                    </div>
                      <div className="menu-item" onClick={() => toggleSubSection(' Boat racing ')}>
                      <span className="toggle-icon">
                        {subSections.Volleyball ? (<FaRegMinusSquare style={styles.minusIcon} />) : (<AiOutlinePlusSquare style={styles.plusIcon} />)}
                      </span>{' '}
                      Boat racing 
                    </div>
                      <div className="menu-item" onClick={() => toggleSubSection(' Ice Hockey ')}>
                      <span className="toggle-icon">
                        {subSections.Volleyball ? (<FaRegMinusSquare style={styles.minusIcon} />) : (<AiOutlinePlusSquare style={styles.plusIcon} />)}
                      </span>{' '}
                      Ice Hockey 
                    </div>
                      <div className="menu-item" onClick={() => toggleSubSection('Rugby union')}>
                      <span className="toggle-icon">
                        {subSections.Volleyball ? (<FaRegMinusSquare style={styles.minusIcon} />) : (<AiOutlinePlusSquare style={styles.plusIcon} />)}
                      </span>{' '}
                      Rugby union 
                    </div>
                      <div className="menu-item" onClick={() => toggleSubSection('MotorBikes')}>
                      <span className="toggle-icon">
                        {subSections.Volleyball ? (<FaRegMinusSquare style={styles.minusIcon} />) : (<AiOutlinePlusSquare style={styles.plusIcon} />)}
                      </span>{' '}
                      MotorBikes 
                    </div>
                      <div className="menu-item" onClick={() => toggleSubSection('Futsal')}>
                      <span className="toggle-icon">
                        {subSections.Volleyball ? (<FaRegMinusSquare style={styles.minusIcon} />) : (<AiOutlinePlusSquare style={styles.plusIcon} />)}
                      </span>{' '}
                      Futsal 
                    </div>
                  </div>
                )}
              </div>
            </div>
          </nav>

        </app-sidebar>
      </div>
    </>
  );
};